module.exports = __webpack_public_path__ + "static/img/2.29ae49a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/eng/2.png
// module id = dmbE
// module chunks = 0